var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-select", {
        attrs: { label: _vm.label, options: _vm.options, mode: "object" },
        on: { input: _vm.handleInput },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "md-style-scoped" }, [
        _c(
          "ul",
          { staticClass: "locations multi-picker" },
          _vm._l(_vm.value, function (option, i) {
            return _c(
              "li",
              [
                _c(
                  "md-chip",
                  {
                    staticClass: "md-primary",
                    attrs: { "md-deletable": "" },
                    on: {
                      "md-delete": function ($event) {
                        return _vm.remove(i)
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        option.attributes
                          ? option.attributes.title
                          : option.name
                      )
                    ),
                  ]
                ),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }